import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function StockoutproducttoproductorderInfo(){
  const { stockoutproducttoproductorderObj} = useSelector((state)=>state.manufslice.stockoutproducttoproductorderDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ stockoutproducttoproductorderObj.businessid!==null && stockoutproducttoproductorderObj.businessid!==undefined?stockoutproducttoproductorderObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Title"  value={ stockoutproducttoproductorderObj.title!==null && stockoutproducttoproductorderObj.title!==undefined?stockoutproducttoproductorderObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="stockoutproductid"  value={ stockoutproducttoproductorderObj.stockoutproductid!==null && stockoutproducttoproductorderObj.stockoutproductid!==undefined?stockoutproducttoproductorderObj.stockoutproductid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="productorderid"  value={ stockoutproducttoproductorderObj.productorderid!==null && stockoutproducttoproductorderObj.productorderid!==undefined?stockoutproducttoproductorderObj.productorderid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Order Id"  value={ stockoutproducttoproductorderObj.orderid!==null && stockoutproducttoproductorderObj.orderid!==undefined?stockoutproducttoproductorderObj.orderid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Qty"  value={ stockoutproducttoproductorderObj.qty!==null && stockoutproducttoproductorderObj.qty!==undefined?stockoutproducttoproductorderObj.qty:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Stock Out Req Id"  value={ stockoutproducttoproductorderObj.stockoutreqid!==null && stockoutproducttoproductorderObj.stockoutreqid!==undefined?stockoutproducttoproductorderObj.stockoutreqid:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}